module.exports = __webpack_public_path__ + "assets/8f9b760cd62a14aedb4391712871eeae.png";